export default {
  setMainCompanyInfo: (state, data) => {
    state.mainCompanyInfo = data;
  }
};
